<div
  ktOffcanvas
  [options]="offcanvasOptions"
  id="kt_entity_details_offcanvas"
  class="offcanvas offcanvas-right p-5"
  style="background-color: #edeff7"
>
  <div class="close">
    <a id="kt_entity_details_close" class="btn btn-xs btn-icon btn-success" (click)="close()">
      <i class="ki ki-close icon-xs"></i>
    </a>
  </div>
  <div class="offcanvas-content h-100 scroll-bar">
    <div class="row align-items-stretch h-100">
      <kt-patient-edit
        [fromCanvas]="true"
        *ngIf="entity.type === 'PATIENT'"
        [entity_id]="entity.id"
        style="width: 100%"
        (focusedViewOpen)="closeComponent($event)"
        (navigateToContact)="closeComponent($event)"
      ></kt-patient-edit>
      <kt-doctor-edit
        [fromCanvas]="true"
        *ngIf="entity.type === 'DOCTOR'"
        [entity_id]="entity.id"
        style="width: 100%"
        (focusedViewOpen)="closeComponent($event)"
        (navigateToContact)="closeComponent($event)"
        (navigateToPatient)="closeComponent($event)"
      ></kt-doctor-edit>
      <kt-facility-edit
        [fromCanvas]="true"
        *ngIf="entity.type === 'FACILITY'"
        [entity_id]="entity.id"
        style="width: 100%"
        (focusedViewOpen)="closeComponent($event)"
        (navigateToContact)="closeComponent($event)"
      ></kt-facility-edit>
      <kt-client-edit
        [fromCanvas]="true"
        *ngIf="entity.type === 'CLIENT'"
        [entity_id]="entity.id"
        style="width: 100%"
        (focusedViewOpen)="closeComponent($event)"
        (navigateToContact)="closeComponent($event)"
      ></kt-client-edit>
    </div>
  </div>
</div>
<div class="offcanvas-overlay" id="hide-overlay"></div>
